// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"163":"63f824b0","348":"fd742325","382":"568189a7"}[chunkId] + ".chunk.js");